import styled from 'styled-components';

/** Gutter between masonry columns (matches former grid gap). */
export const STATISTICS_MASONRY_GUTTER_PX = 32;

/**
 * react-masonry-css uses max-width-style breakpoints: the smallest breakpoint
 * with windowWidth <= key wins; otherwise `default` column count is used.
 */
export const STATISTICS_MASONRY_BREAKPOINTS = {
  default: 3,
  1340: 2,
  863: 1,
};

/** Wraps react-masonry-css grid + gutter styles for train / transfer statistics pages. */
export const StatisticsChartsMasonry = styled.div`
  .statistics-masonry-grid {
    display: flex;
    margin-left: ${-STATISTICS_MASONRY_GUTTER_PX}px;
    width: auto;
  }

  .statistics-masonry-grid_column {
    padding-left: ${STATISTICS_MASONRY_GUTTER_PX}px;
    background-clip: padding-box;
  }

  .statistics-masonry-grid_column > * {
    margin-bottom: ${STATISTICS_MASONRY_GUTTER_PX}px;
  }
`;
